/**
 * Generated runtime TestId mirror for frontend/src/features/onboarding/components/AttributeFormRenderer.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AttributeFormRendererTestIds = {
  attributeSectionToggle: "attribute-section-toggle",
  attribute: (definition_name: string) => `attribute-${definition_name}`,
  attributePrefix: () => "attribute-" as TestIdPrefix
} as const;
